import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["businessStartDate", "yearsInBusiness", "businessAddress", "entityType", "industry", "trigger"]

  connect() {
    if (this.hasTriggerTarget) {
      this.triggerTargets.forEach(trigger => {
        if (this.hasData(trigger)) {
          setTimeout(() => {
            this.populateFromTrigger(trigger)
          }, 100)
        }
      })
    }
  }

  triggerTargetConnected(element) {
    setTimeout(() => {
      this.populateFromTrigger(element)
    }, 100)
  }

  hasData(trigger) {
    return trigger.dataset.businessStartDate ||
           trigger.dataset.yearsInBusiness ||
           trigger.dataset.industry ||
           trigger.dataset.entityType
  }

  populateFromTrigger(triggerElement) {
    const businessStartDate = triggerElement.dataset.businessStartDate
    const yearsInBusiness = triggerElement.dataset.yearsInBusiness
    const businessAddress = triggerElement.dataset.businessAddress
    const entityType = triggerElement.dataset.entityType
    const industry = triggerElement.dataset.industry

    if (businessStartDate && this.hasBusinessStartDateTarget) {
      this.businessStartDateTarget.value = businessStartDate
    }

    if (yearsInBusiness && this.hasYearsInBusinessTarget) {
      this.yearsInBusinessTarget.value = yearsInBusiness
    }

    if (businessAddress && this.hasBusinessAddressTarget) {
      this.businessAddressTarget.value = businessAddress
    }

    if (entityType && this.hasEntityTypeTarget) {
      this.entityTypeTarget.value = entityType
      this.entityTypeTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }

    if (industry && this.hasIndustryTarget) {
      this.industryTarget.value = industry
      this.industryTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  populate(event) {
    const { businessStartDate, yearsInBusiness, businessAddress } = event.detail

    if (businessStartDate && this.hasBusinessStartDateTarget) {
      this.businessStartDateTarget.value = businessStartDate
    }

    if (yearsInBusiness && this.hasYearsInBusinessTarget) {
      this.yearsInBusinessTarget.value = yearsInBusiness
    }

    if (businessAddress && this.hasBusinessAddressTarget) {
      this.businessAddressTarget.value = businessAddress
    }
  }
}
